import { shallowEqual, useSelector } from "react-redux";
import { useRef } from "react";
import { AppState } from "@Store/index";
import Image from "@Components/Image";
import ErrorBoundary from "@Components/ErrorBoundary";
import config from "@Config/index";
import wrapperHOC from "@Utils/wrapperHOC";
import loadable from "@loadable/component";
import FullPageLoader from "@Components/FullPageLoader";

const MapSectionChinaV2 = loadable(() => import("./MapSectionChinaV2"), {
  fallback: <FullPageLoader />,
});

const MapSectionV2 = loadable(() => import("./MapSectionV2"), {
  fallback: <FullPageLoader />,
});

let staticMapUrl = "https://assets.dev-amber.com/regions/14/0ac51277.jpg?auto=compress&trim=auto";

const SearchMapWrapper = ({
  showMapboxGlobal,
  enableClustering = false,
  userCoordinates,
  onCloseMap,
  closeMapLabel,
}: {
  showMapboxGlobal: boolean;
  enableClustering?: boolean;
  userCoordinates?: { lat: number; lng: number };
  onCloseMap?: () => void;
  closeMapLabel?: string;
}) => {
  const navControlsSlotRef = useRef<HTMLDivElement>(null);
  const { region, customLocation, showZones } = useSelector(
    ({ searchPageData }: AppState) => ({
      region: searchPageData.region,
      customLocation: searchPageData.customLocation,
      showZones: searchPageData?.showZones || false,
    }),
    shallowEqual,
  );

  const initialDestinationCoordinates =
    userCoordinates ||
    customLocation?.geometry?.location ||
    region?.location?.location_coordinates ||
    {};

  if (region?.meta?.static_map_url) staticMapUrl = region?.meta?.static_map_url;

  if (region && region?.location && region?.location?.location_coordinates) {
    return (
      <ErrorBoundary isComponentLevel>
        {config.IS_CHINA_APP || showMapboxGlobal ? (
          <MapSectionChinaV2
            staticMapUrl={staticMapUrl}
            locationCoordinates={initialDestinationCoordinates}
            showZones={showZones}
            enableClustering={enableClustering}
            onCloseMap={onCloseMap}
            closeMapLabel={closeMapLabel}
            navControlsSlotRef={navControlsSlotRef}
          />
        ) : (
          <MapSectionV2
            staticMapUrl={staticMapUrl}
            locationCoordinates={initialDestinationCoordinates}
            showZones={showZones}
          />
        )}
      </ErrorBoundary>
    );
  }

  return <Image src={staticMapUrl} alt="static-map-url" width="100%" height="100%" />;
};

export default wrapperHOC(SearchMapWrapper, {
  componentName: "SearchMapWrapper",
  showForChina: true,
});
